import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
  Spinner,
} from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetActivityHistory } from "../../hooks/useActivities";
import ActivityHistoryList from "./ActivityHistoryList";
import { useGetActivityFields } from "../../hooks/useActivities";

const useStyles = makeStyles({
  dialogSurface: {
    minWidth: "1000px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  commentTextArea: {
    minHeight: "150px",
  },
  commentLabel: {
    marginTop: "20px",
  },
});

interface ActivityHistoryDialogProps {
  activityId: string;
}

export const ActivityHistoryDialog = (props: ActivityHistoryDialogProps) => {
  const { activityId } = props;

  const { data: activities, isLoading: loadingHistory } =
    useGetActivityHistory(activityId);

  const { data: viewDefinition, isLoading: loadingViewDefinition } =
    useGetActivityFields();

  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogTrigger disableButtonEnhancement>
        <Button onClick={() => setOpen(true)}>{t("showHistory")}</Button>
      </DialogTrigger>
      <DialogSurface
        className={classes.dialogSurface}
        aria-describedby={undefined}
      >
        <DialogBody>
          <DialogTitle>{t("history")}</DialogTitle>
          <DialogContent>
            {(loadingHistory || loadingViewDefinition) && <Spinner />}
            {!(loadingHistory || loadingViewDefinition) &&
              activities &&
              viewDefinition && (
                <ActivityHistoryList
                  activities={activities}
                  activityFields={viewDefinition!.fields}
                />
              )}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button onClick={() => setOpen(false)} appearance="secondary">
                {t("close")}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
